import type { ElementDefinition } from './types';
import type { TemplateProfile } from '../templates';
import { insertExhibit } from '../word/exhibit';

/** Element definition for table + graph exhibit insertion. */
export const tableGraphExhibitElement: ElementDefinition = {
  id: 'table-graph-exhibit',
  label: 'Table + Graph',
  icon: 'TableCellsSplitRegular',
  description: 'Half-width Table on Left, Graph on Right',
  category: 'exhibit',
  async insertAsync(profile: TemplateProfile): Promise<void> {
    await insertExhibit('table-graph', profile);
  },
};

/** Toolbar action for table + graph exhibit insertion. */
export async function insertTableGraphLayout(profile: TemplateProfile): Promise<void> {
  await insertExhibit('table-graph', profile);
}
